import { regex } from './common'
export default regex('alphaNum', /^[a-zñáéíóúA-zÑÁÉÍÓÚ ]{1,100}$/)